import { render, staticRenderFns } from "./OurWork.vue?vue&type=template&id=b40600ba"
import script from "./OurWork.vue?vue&type=script&lang=js"
export * from "./OurWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports